import {combineReducers, Reducer} from 'redux'
import {ProvincesState} from '@models/province'
import {ProvincesActionTypes} from '@actions/province';


// Type-safe initialState!
export const initialState: ProvincesState = {
    allIds: [],
    byId: {},
    loading: false,
    count: 0
};


const byId = (state = initialState.byId, action) => {
    switch (action.type) {
        case ProvincesActionTypes.FETCH_SUCCESS: {
            const {data} = action.payload;
            return {
                ...data.reduce((obj, province) => {
                    obj[province.id] = {
                        ...province,
                        is_fetched: false,
                        ...(state[province.id] || {}), //The data which fetch by id is more than data in Table
                    };
                    return obj;
                }, {})
            };
        }

        case ProvincesActionTypes.CREATE_SUCCESS: {
            const province = action.payload;
            return {
                ...state,
                [province.id]: province
            };
        }

        case ProvincesActionTypes.UPDATE_SUCCESS: {
            const province = action.payload;
            return {
                ...state,
                [province.id]: {
                    ...state[province.id],
                    ...province
                }
            };
        }

        case ProvincesActionTypes.FETCH_ITEM_SUCCESS: {
            const province = action.payload;
            return {
                ...state,
                [province.id]: {
                    ...state[province.id],
                    ...province,
                    is_fetched: true
                },
            };
        }

        case ProvincesActionTypes.DELETE_SUCCESS:
            return Object.keys(state)
                .filter(id => id !== action.payload.id)
                .reduce((result, current) => {
                    result[current] = state[current];
                    return result;
                }, {});


        default:
            return state;
    }
};


const allIds = (state = initialState.allIds, action) => {
    switch (action.type) {
        case ProvincesActionTypes.FETCH_SUCCESS: {
            const {data} = action.payload;
            return data.map(item => item.id);
        }

        case ProvincesActionTypes.DELETE_SUCCESS:
            const deletedFormIndex = state.indexOf(action.payload.id);
            return [...state.slice(0, deletedFormIndex), ...state.slice(deletedFormIndex + 1)];

        case ProvincesActionTypes.CREATE_SUCCESS:
            return [action.payload.id, ...state];

        default:
            return state
    }
};


const count = (state = initialState.count, action) => {
    switch (action.type) {
        case ProvincesActionTypes.FETCH_SUCCESS: {
            const {meta} = action.payload;
            return meta.total_count;
        }

        case ProvincesActionTypes.DELETE_SUCCESS:
            return state - 1;

        case ProvincesActionTypes.CREATE_SUCCESS:
            return state + 1;


        default:
            return state
    }
};

const loading = (state = initialState.loading, action) => {
    switch (action.type) {
        case ProvincesActionTypes.FETCH_REQUEST: {
            return true;
        }

        case ProvincesActionTypes.FETCH_SUCCESS:
        case ProvincesActionTypes.FETCH_ERROR:
            return false;

        default:
            return state
    }
};


const reducer: Reducer<ProvincesState> = combineReducers({
    byId,
    allIds,
    count,
    loading
});

export {reducer as provinceReducer}


//Selectors
export const getProvincesList = provinces => provinces.allIds.map(id => provinces.byId[id]);

export const getProvinceById = (provinces, id) => provinces.byId[id];